<h1 mat-dialog-title *ngIf="data.title">{{ data.title }}</h1>
<div mat-dialog-content>
  <mat-list role="list">
    <mat-list-item *ngFor="let item of errors" role="listitem">{{ item }}</mat-list-item>
  </mat-list>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close (click)="dismissPressed()">Dismiss</button>
</div>
